export const DocAnalyzerApi = Symbol('DocAnalyzerApi');

export interface DocAnalyzerApi {
  getUsage(): Promise<Record<any, any>>;
  uploadFile(file: File, onProgress?: (percent: number) => void): Promise<Record<any, any>>;
  extractBatch(file_ids: string[]): Promise<Record<any, any>>;
  getExample(language: string, file_id: string): Promise<Record<any, any>>;
}
